// Same strings as the backend's src/common/types/auth.ts.
export const PERMISSIONS = [
  "user:read",
  "user:manage",
  "audit:read",
  "company:manage",
  "company_structure:read",
  "company_structure:manage",
  "department:read",
  "department:manage",
  "role:read",
  "role:manage",
  "access_scope:manage",
  "user:mfa_reset",
  "numbering:read",
  "numbering:manage",
  "approval:decide",
  "approval:delegate",
  "approval_policy:read",
  "approval_policy:manage",
  "attachment:upload",
  "attachment:manage",
  "uom:read",
  "uom:manage",
  "item:read",
  "item:create",
  "item:submit",
  "item:approve",
  "item:manage",
  "item:status",
  "item_category:manage",
  "lot:read",
  "lot:status",
  "lot:correct_dates",
] as const;
export type Permission = (typeof PERMISSIONS)[number];

/**
 * Same as the backend's SENSITIVE_PERMISSIONS (membership-and-mfa.md rule 14): a role holding
 * any of them must require MFA. The role editor turns the setting on for them.
 */
export const SENSITIVE_PERMISSIONS: readonly Permission[] = [
  "user:manage",
  "user:mfa_reset",
  "role:manage",
  "access_scope:manage",
  "approval:decide",
  "approval:delegate",
  "item:approve",
];
